<template>
  <TopNavbar v-bind:links="links"></TopNavbar>
  <div id="mappage" v-if="content" v-bind:style=" 'border-left: 20px solid' + color">
    <ScrollMap v-bind:content="content.content" v-bind:color="color" v-bind:title="content.name" v-bind:titleType="content.titleType" v-bind:titleImg="content.titleImg" v-bind:background="content.background" ></ScrollMap>
  </div>
  <BottomNavbar v-if="content" v-bind:color="color" v-bind:links="links"></BottomNavbar>
</template>

<script>

import TopNavbar from './components/TopNavbar.vue'
import BottomNavbar from './components/BottomNavbar.vue'
import ScrollMap from './components/ScrollMap.vue'

export default {
  name: 'MapPage2',
  inject:["links"],
  components: {
    TopNavbar,
    ScrollMap,
    BottomNavbar
  },
  data(){
    return{
      content:null,
      color:null
    }
  },
  created(){
      this.fetchData();
  },
  watch:{
      '$route':'fetchData'
  },
  methods:{
    fetchData(){
        if (this.$route.params.mappage){
          let self = this;  

          var fileName = "./pages/" + this.$route.params.mappage + ".json";
          const myRequest = new Request(fileName);

          fetch(myRequest)
            .then( res => res.json())
            .then(data => {
                self.content = data;
                self.selectColor();
              })
            .catch(function(error) {
              console.log('Request failed', error)
            });
        }
        window.scrollTo(0,0);
     },
     selectColor(){
       let self = this,
           page = self.$route.params.mappage;

       self.links.forEach(function(link){
         if (link.href == page){
            self.color = link.color;
            self.setColorScheme(self.color);
         }
       })
     },
     setColorScheme(color){
        document.querySelectorAll(".link").forEach(function(link){
           link.style.color = "black";
           link.style.backgroundColor = "rgba(0,0,0,0)";
        });
        document.querySelector(".router-link-exact-active").style.color = "white";
        document.querySelector(".router-link-exact-active").style.backgroundColor = color;
     }
  }
}
</script>

<style>

</style>
